<footer>
  <div class="grid-col-12 footer-bar">
    <nav>
      <div class="display-flex flex-justify-center flex-align-center flex-wrap">
        <ng-container *ngFor="let footerLink of footerLinks; let i = index">
          <div class="footer-item">
            <a [href]="footerLink.url" target="_blank">{{ footerLink.name }}</a>
            <span *ngIf="i !== footerLinks.length - 1" class="padding-right-1 padding-left-1">|</span>
          </div>
        </ng-container>
      </div>
    </nav>
  </div>
</footer>
